/// <amd-module name="Tfs/ReduxCommon/Modules/CommandViewAction/CommandViewActionModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { IModule } from "redux-dynamic-modules";
import { CommandViewActionActions } from "./CommandViewActionActions";
import { CommandMap, ICommandAwareState } from "./CommandViewActionContracts";
import { commandViewActionReducer } from "./CommandViewActionReducer";

export function getCommandViewModule(initialCommands: CommandMap, initialViewActions: CommandMap): IModule<ICommandAwareState> {
    const reducerMap: ReducersMapObject<ICommandAwareState, AnyAction> = {
        commandsState: commandViewActionReducer
    };

    return {
        id: "command-viewaction-module",
        reducerMap,
        initialActions: [CommandViewActionActions.addCommands(initialCommands), CommandViewActionActions.addViewActions(initialViewActions)]
    };
}
